import { render, staticRenderFns } from "./AdminOrderButton.vue?vue&type=template&id=459f2201"
import script from "./AdminOrderButton.vue?vue&type=script&lang=js"
export * from "./AdminOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports